import { UserStateType } from 'api/graphQL/reactiveVars/usersReactiveVar'

export enum NoteType {
    GeneralNote = 'GENERALNOTE',
    DeleteOrStatusChange = 'DELETEORSTATUSCHANGE',
    ListingTypeChange = 'LISTINGTYPECHANGE',
    CopyMove = 'COPYMOVE',
}

export type NoteTypeReasonOption = {
    noteType: NoteType
    reason: string
}

export type ProductDetailNoteData = {
    id: string
    listingId: string
    longDescription: string
    noteType: NoteType
    reason: string
    seenByUserId: string[]
    createdDate: string
    userName: string
    userRole: string
    userId: string
    isTemporary?: boolean
}

export type NotesFilterType = {
    users: string[]
    noteTypes: NoteTypeReasonOption[]
    dateFrom: string | null
    dateTo: string | null
}

export type PDNStoreType = {
    listingId: string
    tempNotes: Record<string, Partial<ProductDetailNoteData>>
    count: number
    notes: Record<string, Partial<ProductDetailNoteData>>
    currentUser: Partial<UserStateType>
    noteTypes: NoteType[]
    isLoaded?: boolean
}

export type PDNResponseType = {
    id: string
    listingId: string
    content: string
    reason: string
    productDetailNoteType: string
    seenByUserId: string[]
    metadata: Record<string, string>
}
